import RfiActivityEmptyState from './RfiActivityEmptyState.component';

export default RfiActivityEmptyState;
